export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          Bihar State Open eSports Championship Begins
          <hr />
        </h3>

        <p className="card-text">
          The third edition of the Bihar State Open eSports Championship is
          being organized from 4th to 16th May 2026. The registration process
          for the tournament began on 19th April 2026 and continued till 2nd May
          2026. A total of five game titles - BGMI, Chess.com, eFootball Mobile,
          FC26, and Street Fighter 6 have been included in the tournament, with
          a total of 2,182 participants registering across all titles. In terms
          of participation by game title, Chess recorded 1,151 registrations,
          while eFootball Mobile saw 223 participants, FC26 had 162
          participants, and Street Fighter 6 recorded 35 participants.
          Meanwhile, BGMI registered a total of 611 teams, with each team
          consisting of 4 to 5 members. The online matches of the championship
          have already commenced from 4th May 2026, while the LAN Grand Finale
          will be held on 16th May 2026 at the Indoor Stadium, Patliputra Sports
          Complex, Patna.
        </p>
        <br />
      </div>
    </div>
  );
}
